// MARK://dhk8/pos/lib/queries/users
// Query tipada de un usuario de staff — F6.2 R3d / ADR-0009. El POS resuelve
// `userId → displayName` (p. ej. "Atendió: …" en el ticket) por el grafo
// (platform-auth, tenant del JWT). Read tenant-scoped (no privilegio). Reemplaza
// el GET REST /api/users/:id. NUNCA expone hash/credenciales.
import { graphql } from '../../gql/index.js'

export const PosStaffUserQuery = graphql(`
  query PosStaffUser($id: ID!) {
    staffUser(id: $id) {
      id
      email
      fullName
      role
    }
  }
`)
